import type { AppConfig } from "../../types/appConfig";
import { assertResponseOk, expectStatuses, fetchZekay } from "../zekay/httpClient";
import type {
  CommunicationSettings,
  MailPlaceholderDefinition,
  MailTemplate,
  MailTemplateType,
} from "./MailTemplate.typed";

export class MailTemplateModel {
  zekayAPI: string;
  constructor(config: AppConfig) {
    this.zekayAPI = config.zekayAPI;
  }
  async listMailTemplates(type?: MailTemplateType): Promise<MailTemplate[]> {
    const query = type ? "?" + new URLSearchParams({ type }).toString() : "";
    const r = await fetchZekay(this.zekayAPI + "/mail-templates" + query);
    await expectStatuses(r, 200, 204);
    if (r.status === 204) return [];
    return (await r.json()) as MailTemplate[];
  }
  async getMailTemplate(id: number): Promise<MailTemplate> {
    const r = await fetchZekay(this.zekayAPI + "/mail-templates/" + id);
    await assertResponseOk(r);
    return (await r.json()) as MailTemplate;
  }
  async createMailTemplate(payload: MailTemplate): Promise<MailTemplate> {
    const r = await fetchZekay(this.zekayAPI + "/mail-templates", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    await expectStatuses(r, 201);
    return (await r.json()) as MailTemplate;
  }
  async updateMailTemplate(id: number, payload: MailTemplate): Promise<void> {
    const r = await fetchZekay(this.zekayAPI + "/mail-templates/" + id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    await expectStatuses(r, 200, 204);
  }
  async deleteMailTemplate(id: number): Promise<void> {
    const r = await fetchZekay(this.zekayAPI + "/mail-templates/" + id, { method: "DELETE" });
    await expectStatuses(r, 204);
  }

  async listMailPlaceholderDefinitions(
    templateType: MailTemplateType,
  ): Promise<MailPlaceholderDefinition[]> {
    const q = new URLSearchParams({ type: templateType });
    const r = await fetchZekay(`${this.zekayAPI}/mail-templates/placeholders?${q.toString()}`);
    await assertResponseOk(r);
    return (await r.json()) as MailPlaceholderDefinition[];
  }

  async previewMailTemplateHtml(bodyHtml: string, type: MailTemplateType): Promise<string> {
    const r = await fetchZekay(this.zekayAPI + "/mail-templates/preview", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ html: bodyHtml, type }),
    });
    await assertResponseOk(r);
    const j = (await r.json()) as { html?: string };
    return j.html ?? "";
  }

  async getCommunicationSettings(): Promise<CommunicationSettings> {
    const r = await fetchZekay(this.zekayAPI + "/communication-settings");
    await assertResponseOk(r);
    return (await r.json()) as CommunicationSettings;
  }

  async updateCommunicationSettings(payload: CommunicationSettings): Promise<void> {
    const r = await fetchZekay(this.zekayAPI + "/communication-settings", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    await expectStatuses(r, 200, 204);
  }
}
